import type { BaseAPIResponse } from '~/types/api';
import type { Company } from '~/types/person/companies';
import { pbRequestRaw } from '~/services/request';

// Pure API service for public endpoints - no authentication needed
export const publicService = {
    async searchCompaniesV3(
        query: string = '',
        perPage: number = 10,
        page: number = 1,
        type: string = '',
        license?: string
    ): Promise<BaseAPIResponse<Company[]>> {
        const nuxtApp = useNuxtApp();

        // The whole envelope is the answer: callers page on its `meta`.
        return await pbRequestRaw<BaseAPIResponse<Company[]>>(
            nuxtApp.$api.routes.public.companies.search(query, perPage, page, type, false, license),
            { failure: 'No companies data received' }
        );
    },
};
